import { useForm, FormProvider } from "react-hook-form";
import { format as dateFormat, add as dateAdd } from "date-fns";
// import { Dropdown, DropdownButton, ButtonGroup } from "react-bootstrap";
// import useLocalStorage from "../../../../../hooks/useLocalStorage";

// Constants
import { orderHistoryVars } from "../../../../../constants";

// Components
import OrderHistoryIcons from "./OrderHistoryIcons";
import OrderHistorySearch from "./OrderHistorySearch";

function TableToolbar({
  isLoading,
  onSearch,
  mode,
  onChangeMode,
  doesOrderExist = false,
  orders,
}) {
  const methods = useForm({
    defaultValues: {
      fromDate: dateFormat(
        dateAdd(new Date(), { days: orderHistoryVars.defaultFromOffset }),
        "yyyy-MM-dd",
      ),

      toDate: dateFormat(
        dateAdd(new Date(), { days: orderHistoryVars.defaultToOffset }),
        "yyyy-MM-dd",
      ),
    },
  });

  return (
    <FormProvider {...methods}>
      <div className="tw-mb-3 lg:tw-mb-6">
        <OrderHistorySearch
          isLoading={isLoading}
          handleOnSubmitOrdersSearch={onSearch}
        />

        <OrderHistoryIcons
          mode={mode}
          onChangeMode={onChangeMode}
          doesOrderExist={doesOrderExist}
          orders={orders}
          isLoading={isLoading}
        />
      </div>
    </FormProvider>
  );
}

export default TableToolbar;
